<sesio-chart kind="highstock" class="chart" [options]="options" (ready)="load($event)">
</sesio-chart>